import React from "react";
import { Route } from "react-router-dom";
import { ImportMutationBankCard } from "./ImportMutationBankCard";
import { ImportMutationBankCreateDialog } from "./import-mutation-bank-create-dialog/ImportMutationBankCreateDialog";
import { ImportMutationBankUIProvider } from "./ImportMutationBankUIContext";
import { PrivateRoute } from "../../../../PrivateRoute";
import { RoleChecker } from "../../../../RoleChecker";

export function ImportMutationBankPage({ history }) {
  const importMutationImportMutationBankUIEvents = {
    newImportMutationBankButtonClick: () => {
      history.push("/donasi/bank-import/new");
    },
    openEditImportMutationBankPage: (id) => {
      history.push(`/donasi/bank-import/${id}/edit`);
    },
  };

  return (
    <ImportMutationBankUIProvider
      importMutationImportMutationBankUIEvents={
        importMutationImportMutationBankUIEvents
      }
    >
      <PrivateRoute
        role={RoleChecker("Create", "bank_import")}
        component={ImportMutationBankCreateDialog}
        path="/donasi/bank-import/new"
      />
      <PrivateRoute
        role={RoleChecker("Edit", "bank_import")}
        component={ImportMutationBankCreateDialog}
        path="/donasi/bank-import/:id/edit"
      />
      <ImportMutationBankCard />
    </ImportMutationBankUIProvider>
  );
}
